/**
 * Integrations / Notification Center module gate (Vite: VITE_ENABLE_INTEGRATIONS_MODULE).
 * - `VITE_ENABLE_INTEGRATIONS_MODULE=false` → legacy IntegrationsPage only
 * - `VITE_ENABLE_INTEGRATIONS_MODULE=true` → always on
 * - unset → on in development only
 */
export function isIntegrationsModuleEnabled(): boolean {
  const v = import.meta.env.VITE_ENABLE_INTEGRATIONS_MODULE;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return Boolean(import.meta.env.DEV);
}
